module.exports = __webpack_public_path__ + "611b7d6991d9d731bed92479cded3e8e.png";